import React, { useState } from "react";
import Typography from "@mui/material/Typography";
import { useSelector, useDispatch } from "react-redux";

import { SNETTextfield, alertTypes } from "shared/dist/components";
import validator from "shared/dist/utils/validator";
import { organizationActions } from "../../../../Services/Redux/actionCreators";
import { ContactsTypes } from "../../../../Utils/Contacts";
import { contactConstraints } from "../validationConstraints";
import classes from "./SupportDetails.module.css";

const SupportDetails = () => {
    const contacts = useSelector((state) => state.organization.contacts);
    let supportContacts = contacts.find((el) => el.type === ContactsTypes.SUPPORT);
    if (!supportContacts) {
        supportContacts = { type: ContactsTypes.SUPPORT, phone: "", email: "" };
    }
    const dispatch = useDispatch();

    const [phoneValidation, setPhoneValidation] = useState();
    const [emailValidation, setEmailValidation] = useState();

    const handlePhoneValidation = (value) => {
        const invalidPhoneMessage = validator.single(value, contactConstraints.phone);
        if (invalidPhoneMessage) {
            setPhoneValidation({
                type: alertTypes.ERROR,
                message: invalidPhoneMessage[0], // invalidPhoneMessage is single-element array
            });
        } else {
            setPhoneValidation();
        }
    };

    const handleEmailValidation = (value) => {
        const invalidEmailMessage = validator.single(value, contactConstraints.email);
        if (invalidEmailMessage) {
            setEmailValidation({
                type: alertTypes.ERROR,
                message: invalidEmailMessage[0], // invalidEmailMessage is single-element array
            });
        } else {
            setEmailValidation();
        }
    };

    const handleValidation = {
        email: handleEmailValidation,
        phone: handlePhoneValidation,
    };

    const handleFormInputsChange = (event) => {
        const { name, value } = event.target;
        handleValidation[name](value);

        const index = contacts.findIndex((el) => el.type === ContactsTypes.SUPPORT);
        const updatedContacts = [...contacts];
        if (index !== -1) {
            updatedContacts[index] = { ...contacts[index], [name]: value };
        } else {
            updatedContacts[contacts.length] = { type: ContactsTypes.SUPPORT, [name]: value };
        }

        dispatch(organizationActions.setContacts(updatedContacts));
    };

    return (
        <div className={classes.supportDetailsContainer}>
            <Typography variant="h6" className={classes.heading}>
                Support Contact
            </Typography>
            <Typography variant="subtitle2">
                Please provide your organization contact information for AI Marketplace users to
                contact you regarding your published AI services.
            </Typography>
            <SNETTextfield
                label="Support Email"
                description="This email address will be displayed to AI Marketplace users."
                name="email"
                value={supportContacts.email}
                onChange={handleFormInputsChange}
                error={emailValidation}
            />
            <SNETTextfield
                label="Phone Number (Optional)"
                description="Include plus sign, country code and area code.  For example +18005551234."
                name="phone"
                value={supportContacts.phone}
                onChange={handleFormInputsChange}
                error={phoneValidation}
            />
        </div>
    );
};

export default SupportDetails;
